import React, { useState } from "react";
import Tab from "@visa/vds/tab";
import TabList from "@visa/vds/tab-list";
import DafTabOneRequestTable from "./DafTabOneRequestTable";
import DafTabThreeRequestTable from "./DafTabThreeRequestTable.jsx";
import { DafUploadApi } from "../../../services/daf.upload.service";
import DafTabRequestDialog from "./DafTabRequestDialog";
import DafTabOneRequestDetails from "./DafTabOneRequestDetails";
import DafTabThreeRequestDetails from "./DafTabThreeRequestDetails";

const DafTabRequestList = (props) => {
  const dafUpload = props.dafUpload;
  const alertObj = props.alertObj;
  const [selectedRequestTab, setSelectedRequestTab] = useState(0);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [tabOneRequest, setTabOneRequest] = useState(null);
  const [tabTwoRequest, setTabTwoRequest] = useState(null);
  const [tabThreeRequest, setTabThreeRequest] = useState(null);

  const DIALOG_TITLE_TAB_ONE_REQUEST = "Tab One Request";
  const DIALOG_TITLE_TAB_TWO_REQUEST = "Tab Two Request";
  const DIALOG_TITLE_TAB_THREE_REQUEST = "Tab Three Request";

  const setSelectedTab = (e, k) => {
    setSelectedRequestTab(k);
  };

  const isTabHidden = (tabNo) => {
    return selectedRequestTab === tabNo ? undefined : "hidden";
  };

  const setOpenTabRequestDialog = (request, dialogTitle, setRequest) => {
    setDialogTitle(dialogTitle);
    setRequest(request);
    setOpenDialog(true);
  };

  const renderDialogBody = () => {
    if (tabOneRequest)
      return <DafTabOneRequestDetails tabOneRequest={tabOneRequest} />;
    else if (tabTwoRequest)
      return <DafTabOneRequestDetails tabOneRequest={tabTwoRequest} />;
    else if (tabThreeRequest)
      return <DafTabThreeRequestDetails tabThreeRequest={tabThreeRequest} />;
  };

  const setCloseDialog = () => {
    setOpenDialog(false);
    setTabOneRequest(null);
    setTabTwoRequest(null);
    setTabThreeRequest(null);
  };

  return (
    <>
      <TabList selectedTab={selectedRequestTab}>
        <Tab
          onClick={setSelectedTab}
          aria-controls="vds-tab-panel-daf-tab-one-request"
        >
          Tab 1 - 3DS Registration w VMID
        </Tab>
        <Tab
          onClick={setSelectedTab}
          aria-controls="vds-tab-panel-daf-tab-two-request"
        >
          Tab 2 - 3DS Registration wo VMID
        </Tab>
        <Tab
          onClick={setSelectedTab}
          aria-controls="vds-tab-panel-daf-tab-three-request"
        >
          Tab 3 - 3DS Acquirer Contacts
        </Tab>
      </TabList>
      <div
        id="vds-tab-panel-daf-tab-one-request"
        hidden={isTabHidden(0)}
        tabIndex="0"
        role="tabpanel"
      >
        <DafTabOneRequestTable
          dafUpload={dafUpload}
          alertObj={alertObj}
          fetchData={DafUploadApi.getTabOneRequests}
          handleClickAction={(request) =>
            setOpenTabRequestDialog(
              request,
              DIALOG_TITLE_TAB_ONE_REQUEST,
              setTabOneRequest
            )
          }
        />
      </div>
      <div
        id="vds-tab-panel-daf-tab-two-request"
        hidden={isTabHidden(1)}
        tabIndex="0"
        role="tabpanel"
      >
        <DafTabOneRequestTable
          dafUpload={dafUpload}
          alertObj={alertObj}
          fetchData={DafUploadApi.getTabTwoRequests}
          handleClickAction={(request) =>
            setOpenTabRequestDialog(
              request,
              DIALOG_TITLE_TAB_TWO_REQUEST,
              setTabTwoRequest
            )
          }
        />
      </div>
      <div
        id="vds-tab-panel-daf-tab-three-request"
        hidden={isTabHidden(2)}
        tabIndex="0"
        role="tabpanel"
      >
        <DafTabThreeRequestTable
          dafUpload={dafUpload}
          alertObj={alertObj}
          fetchData={DafUploadApi.getTabThreeRequests}
          handleClickAction={(request) =>
            setOpenTabRequestDialog(
              request,
              DIALOG_TITLE_TAB_THREE_REQUEST,
              setTabThreeRequest
            )
          }
        />
      </div>
      <DafTabRequestDialog
        openDialog={openDialog}
        setCloseDialog={setCloseDialog}
        dialogTitle={dialogTitle}
        renderDialogBody={renderDialogBody}
      />
    </>
  );
};
export default DafTabRequestList;
